import React from 'react';
import { useNavigate } from 'react-router-dom';
import resumeBeen from '../../../image/resumebeen.svg';

const Questnavbar = ({ onNavigate }) => {
  const navigate = useNavigate();

  const handleClick = (path) => {
    if (onNavigate) {
      onNavigate(path);
    } else {
      navigate(path);
    }
  };

  return (
    <div className="sticky top-0 bg-white w-full z-[9999999] border-b-0 border-gray-200">
      <div className="flex items-center justify-between px-8 py-3 bg-white text-slate-700">
        <div className="flex items-center justify-between space-x-20 lg:ml-12">
          <div className="flex justify-between space-x-4">
            <p
              onClick={() => handleClick('/')}
              aria-label="Go to Home page"
              className="flex items-center cursor-pointer"
            >
              <img src={resumeBeen} className="w-40" alt="Logo" />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Questnavbar;